import ADPUsrService from "../../../../../services/admin/ADPUsrService";
import ADPDeptService from "../../../../../services/admin/ADPDeptService";
import ADPDsgnService from "../../../../../services/admin/ADPDsgnService";
import ADPRefcodeService from "../../../../../services/admin/ADPRefcodeService";
import ADPAcsService from "../../../../../services/admin/ADPAcsService";
import ADPTntService from "../../../../../services/admin/ADPTntService";
import ADPUsrtntService from "../../../../../services/admin/ADPUsrtntService";

class UserService {

    async getClientState(): Promise<any> {
        const clientState = localStorage.getItem('clientState');
        return clientState ? JSON.parse(clientState) : null
    }

    async getUserById(userId: string): Promise<any> {
        return await ADPUsrService.getItemById(userId);
    }

    async userList(facilityCode: string): Promise<any> {
        return await ADPUsrService.findAll(facilityCode);
    }

    async create(user: any): Promise<any> {
        return await ADPUsrService.create(user);
    }

    async update(userId: string, user: any): Promise<any> {
        return await ADPUsrService.update(userId, user);
    }
    async getDeptDropdown(): Promise<any> {
        return await ADPDeptService.getDropdown();
    }
    async getDsgnDropdown(): Promise<any> {
        return await ADPDsgnService.getDropdown();
    }

    async getAcsDropdown(facilityCode: any): Promise<any> {
        return await ADPAcsService.getDropdown(facilityCode);
    }

    async getUserTypeDropdown(referenceGroup: string, moduleId: string): Promise<any> {
        return await ADPRefcodeService.getDropdownByModuleIdAndReferencegroup(moduleId, referenceGroup);
    }

    async getSystemActorDropdown(referenceGroup: string, moduleId: string): Promise<any> {
        return await ADPRefcodeService.getDropdownByModuleIdAndReferencegroup(moduleId, referenceGroup);
    }

    async getFacilityDropdown(codesToExclude: any): Promise<any> {
        return await ADPTntService.getItemsExcludeInFacilityCodes(codesToExclude);
    }

    async getUserTnt(userId: string): Promise<any> {
        return await ADPUsrtntService.getItemsByUserId(userId);
    }

    async createUsrtnt(item: any): Promise<any> {
        return await ADPUsrtntService.create(item);
    }

    
    
}

export default new UserService();